import { Trash } from '@icons';
import React from 'react';
import { Button } from 'react-bootstrap';

interface ResetFilterProps {
    handleFilterReset: () => void;
    activeFilters: { [key: string]: (string)[] };
}

const ResetFilter: React.FC<ResetFilterProps> = ({ handleFilterReset, activeFilters }) => {
    return <Button
        onClick={handleFilterReset}
        disabled={Object.keys(activeFilters).filter(activeFilter => activeFilter !== "sampling").length === 0}
        className="btn custom-ghost-error-button"
        style={{
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
        }}
    >
        rimuovi filtri <Trash />
    </Button>
}

export default ResetFilter